export default __webpack_public_path__ + "static/media/activeList.fec577f9.svg";